import { assign } from "lodash";
import { TimePickerComponent } from "./time-picker.component";
import { FormControl } from "@angular/forms";
import { Field, FieldType } from "../../vforms-model";

export class TimePickerType extends FieldType {
    static Id = "timepicker";

    constructor() {
        super();
        this.id = TimePickerType.Id;
        this.icon = "mat_outline:calendar_today";
        this.previewComponent = TimePickerComponent;
    }

    createField(): Field {
        return new TimePicker(this);
    }
}

export class TimePicker extends Field {
    selectedTime: FormControl = new FormControl();

    placeholder: string;

    constructor(type: FieldType) {
        super(type);
    }

    toJson() {
        const definition = super.toJson();
        assign(definition, {
            placeholder: this.placeholder,
        });
        return definition;
    }
}
